
// Core
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';

// Services
import { HttpClienteService } from '@core/services/http-cliente.service';
@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private readonly url = environment.apiURL;
  user: any;
  constructor(
    public readonly router: Router,
    private readonly _http: HttpClienteService,) {
  }

  getCategories(obj: any) {
    const query = `${this.url}/wcl-material/categories?code=${obj.code}&sector=${obj.sector}&zone=${obj.zone}&schema=${obj.schema}&segment=${encodeURIComponent(obj.segment)}&userType=${obj.userType}`;
    return this._http.get(query);
  }
  getMostWantedCategories(params: { code: string; sector: string; limit: number }) {
    const queryParams = new HttpParams({ fromObject: { ...params } });
    return this._http.get(`${this.url}/wcl-material/categories-most-wanted?${queryParams.toString()}`);
  }
  getSearchCategories(obj: any) {
 const query = `${this.url}/wcl-material/search-products?code=${obj.code}&value=${obj.description}&sector=${obj.sector}&zone=${obj.zone}&schema=${obj.schema}&segment=${encodeURIComponent(obj.segment)}&userType=${obj.userType}`;
    // const query = 'https://run.mocky.io/v3/28733e30-200b-4a94-bb55-e2765a9c0910'
    return this._http.get(query);
  }
}
